import { Loader2 } from 'lucide-react';
import React from 'react';
import { Button } from '../../../components/ui/button';
import { SETTINGS_STRINGS } from '../../../lib/constants';

interface ActionButtonsProps {
  isUpdating: boolean;
  onCancel: () => void;
}

/**
 * Action Buttons Component
 * Cancel and Save buttons for the settings form
 */
export const ActionButtons: React.FC<ActionButtonsProps> = ({ isUpdating, onCancel }) => {
  const strings = SETTINGS_STRINGS.ORGANIZATION_PROFILE;

  return (
    <div className="flex justify-end gap-3 pt-6 border-t border-border">
      <Button type="button" variant="outline" onClick={onCancel} disabled={isUpdating}>
        {strings.CANCEL_BUTTON}
      </Button>
      <Button type="submit" disabled={isUpdating}>
        {isUpdating ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Saving...
          </>
        ) : (
          strings.SAVE_BUTTON
        )}
      </Button>
    </div>
  );
};
